export default __webpack_public_path__ + "static/media/tavernLogo.bb2545d7.jpg";